import { render, staticRenderFns } from "./VendorSelector.vue?vue&type=template&id=b88a4b06&"
import script from "./VendorSelector.vue?vue&type=script&lang=js&"
export * from "./VendorSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports